import { INavData } from '@coreui/angular-pro';
import { UserRole } from '../../authentication/model';

export interface IExtendedNavData extends INavData {
  roles?: UserRole[];
}

export const navItems: IExtendedNavData[] = [
  {
    name: $localize`Dashboard`,
    url: '/secure/dashboard',
    iconComponent: { name: 'cil-speedometer' },
    roles: [UserRole.Any]
  },

  {
    name: $localize`My Loads`,
    url: '/secure/spot-dispatch/driver/my-loads',
    iconComponent: { name: 'cil-truck' },
    roles: [UserRole.DriverDispatch]
  },

  {
    name: $localize`Payroll`,
    url: '/secure/payments/payrolls',
    iconComponent: { name: 'cil-money' },
    roles: [UserRole.ManagerAll, UserRole.Payroll]
  },
  {
    name: $localize`Schedule`,
    url: '/secure/schedule/weekly-schedules',
    iconComponent: { name: 'cil-calendar' },
    roles: [UserRole.ManagerAll, UserRole.Schedule]
  },
  {
    name: $localize`Notifications`,
    url: '/secure/customer-notifications',
    iconComponent: { name: 'cil-bell' },
    roles: [UserRole.ManagerAll, UserRole.Ivmr]
  },
  {
    name: $localize`Spot Dispatch`,
    url: '/secure/spot-dispatch/dashboard',
    iconComponent: { name: 'cil-truck' },
    roles: [UserRole.Dispatch]
  },
  {
    title: true,
    name: $localize`Reports`,
    roles: [UserRole.ManagerAll, UserRole.Maintenance, UserRole.Ivmr, UserRole.Fuel, UserRole.Payroll, UserRole.Schedule]
  },
  {
    name: $localize`MMR reports`,
    url: '/secure/ivmr/mmr',
    iconComponent: { name: 'cil-graph' },
    roles: [UserRole.ManagerAll, UserRole.Ivmr]
  },
  {
    name: $localize`State Miles Report`,
    url: '/secure/ivmr/state-miles-report',
    iconComponent: { name: 'cil-graph' },
    roles: [UserRole.ManagerAll, UserRole.Ivmr]
  },
  {
    name: $localize`Timesheet Report`,
    url: '/secure/reports/driver-timesheet',
    iconComponent: { name: 'cil-graph' },
    roles: [UserRole.ManagerAll, UserRole.Payroll]
  },
  {
    name: $localize`Geofence Trips`,
    url: '/secure/reports/geofence-trips',
    iconComponent: { name: 'cil-map' },
    roles: [UserRole.ManagerAll, UserRole.Ivmr]
  },
  {
    name: $localize`Fuel Report`,
    url: '/secure/reports/fuel',
    iconComponent: { name: 'cil-bar-chart' },
    roles: [UserRole.ManagerAll, UserRole.Fuel]
  },
  {
    name: $localize`DEF Report`,
    url: '/secure/reports/def',
    iconComponent: { name: 'cil-bar-chart' },
    roles: [UserRole.ManagerAll, UserRole.Fuel]
  },
  {
    name: $localize`Profit & Loss`,
    url: '/secure/reports/profit-and-loss',
    iconComponent: { name: 'cil-bar-chart' },
    badge: {
      color: 'info',
      text: $localize`NEW`
    },
    roles: [UserRole.ManagerAll]
  },
  {
    name: $localize`Vehicle Maintenance`,
    url: '/secure/reports/vehicle-maintenance',
    iconComponent: { name: 'cil-bar-chart' },
    badge: {
      color: 'info',
      text: $localize`NEW`
    },
    roles: [UserRole.ManagerAll, UserRole.Ivmr, UserRole.Maintenance]
  },
  {
    name: $localize`Business Performance`,
    url: '/secure/reports/bi-reports/business-performance',
    iconComponent: { name: 'cil-bar-chart' },
    badge: {
      color: 'info',
      text: $localize`NEW`
    },
    roles: [UserRole.DemoAdmin]
  }
  
];